import {
    getCreatorBadgeSignal,
    getCreatorQualitySignal,
} from '../../components/RelatedEvents/api';
import {
    CreatorBadgeResponse,
    CreatorSignalQualityResponse,
} from '../../components/RelatedEvents/types/api';

export interface FetchCreatorQualityDataResult {
    creatorSignalData: CreatorSignalQualityResponse | null;
    creatorBadgeData: CreatorBadgeResponse | null;
}

export const fetchCreatorQualityData = async (
    organizerId: string,
    signal?: AbortSignal,
): Promise<FetchCreatorQualityDataResult> => {
    if (!organizerId) {
        throw new Error(
            'organizerId is required to fetch creator quality data',
        );
    }

    const id = String(Number(organizerId) / 1007);

    const [signalResponse, badgeResponse] = await Promise.allSettled([
        getCreatorQualitySignal(id, signal),
        getCreatorBadgeSignal(id, signal),
    ]);

    if (signal?.aborted) {
        throw new Error('Request was cancelled');
    }

    return {
        creatorSignalData:
            signalResponse.status === 'fulfilled'
                ? (signalResponse.value as CreatorSignalQualityResponse)
                : null,
        creatorBadgeData:
            badgeResponse.status === 'fulfilled'
                ? (badgeResponse.value as CreatorBadgeResponse)
                : null,
    };
};
